/**
* Card Hero JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Hero component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'card-hero',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.card-hero' ).each( function( key, val ) {
        const mediaContentOverlayInner = $( this ).find( '.card-hero__media-content__overlay-inner' )[0];
        const media = $( this ).find( '.card-hero__media' )[0];

        const overlayTimeline = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom 90%',
            scrub: 0,
            // markers: true,
          },
        } );

        const mediaTimeline = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            end: 'bottom top',
            scrub: 0,
            // markers: true,
          },
        } );

        if ( window.innerWidth > 1023 ) {
          overlayTimeline.to( mediaContentOverlayInner, {scaleY: '0', ease: 'linear'}, 0 );
          mediaTimeline.to( media, {y: '20%', ease: 'linear'}, 0 );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-hero', COMPONENT );
} )( app );
